export default __webpack_public_path__ + "3053a74e766158f729090f294f5f6dbc.jpg";